/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { TicketLockDto } from '../../models/ticket-lock-dto';
import { TicketLockItem } from '../../models/ticket-lock-item';

export interface TicketLockControllerRelease$Params {
  id: number;
      body: TicketLockDto
}

export function ticketLockControllerRelease(http: HttpClient, rootUrl: string, params: TicketLockControllerRelease$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TicketLockItem;
}>> {
  const rb = new RequestBuilder(rootUrl, ticketLockControllerRelease.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TicketLockItem;
      }>;
    })
  );
}

ticketLockControllerRelease.PATH = '/ticket/{id}/unlock';
